const URL_REGEX = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

const ValidateURL = (value: string): boolean => {
    return URL_REGEX.test(value);
};

export default { ValidateURL };
